// Valências do utilizador autenticado (permissões por nome de tpValencia).
//
// O gate a sério está no backend (api/utils/valencias.py); isto serve para a
// interface não mostrar botões que iriam devolver 403. A comparação é feita
// pelo nome, sem acentos e sem maiúsculas, para tolerar variações de escrita
// entre schemas.
import axios from "axios";
import { getUser } from "@/extraData";

const baseURl = process.env.VUE_APP_URL_BASE;

// Valência que permite criar/alterar famílias, produtos, tipologias,
// equipamentos e a associação entre equipamentos.
export const GERIR_FAMILIAS_EQUIPAMENTOS = "Gerir famílias e equipamentos";

const normalizar = (valor) =>
  String(valor || "")
    .normalize("NFD")
    .replace(/[̀-ͯ]/g, "")
    .toLowerCase()
    .trim();

// As valências de um utilizador não mudam durante a sessão; guardar a promessa
// evita um pedido por cada ecrã que pergunte.
let valenciasPromise = null;
let valenciasUserId = null;

async function carregarValencias() {
  const userId = getUser()?.id;
  if (!userId) return [];

  if (valenciasPromise && valenciasUserId === userId) {
    return valenciasPromise;
  }

  valenciasUserId = userId;
  valenciasPromise = axios
    .get(
      `${baseURl}/api/v1/utilizadorvalencia/s/utilizador_id/${userId}/?exact=true`
    )
    .then((res) =>
      (res.data?.data || []).map((v) => normalizar(v.tpValencia?.nome))
    )
    .catch((error) => {
      console.error("Erro ao carregar valências do utilizador:", error);
      // Na dúvida não se abre a porta: sem valências o utilizador só consulta.
      valenciasPromise = null;
      return [];
    });

  return valenciasPromise;
}

// Esquece o que está em cache — usar no login/logout ou depois de alterar as
// valências de um utilizador.
export function limparCacheValencias() {
  valenciasPromise = null;
  valenciasUserId = null;
}

export async function temValencia(nome) {
  const valencias = await carregarValencias();
  return valencias.includes(normalizar(nome));
}

export function podeGerirFamiliasEquipamentos() {
  return temValencia(GERIR_FAMILIAS_EQUIPAMENTOS);
}
